import { render, staticRenderFns } from "./virtual.table.vue?vue&type=template&id=14e536b5&"
import script from "./virtual.table.vue?vue&type=script&lang=js&"
export * from "./virtual.table.vue?vue&type=script&lang=js&"
import style0 from "./virtual.table.vue?vue&type=style&index=0&id=14e536b5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports